import { render, staticRenderFns } from "./PerimeterFilter.vue?vue&type=template&id=121994c9"
import script from "./PerimeterFilter.vue?vue&type=script&lang=js"
export * from "./PerimeterFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports